import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSun, faMoon } from "@fortawesome/free-solid-svg-icons";

import { dispatchThemeSave } from "../../../../store/reducers/themeReducer";
import { isDefined } from "../../../../auxiliar/formatValidators";

const ThemeSelector = () => {
    /*
    I find the logic around updatedTheme to be a bit counterintuitive:
    * It is used to store the theme that will be used in the app if the checkbox is checked (isLight), so in other words, if the user manually changed the theme.
    * It has to be the opposite of the default theme of the user's machine and updated when the system preference changes so the DaisiUI theme is taken into account
    * IsLight stores the real theme of the app
    */
    const dispatch = useDispatch();

    const isLight = useSelector((state) => state.themeReducer.lightTheme);
    const updatedTheme = useSelector((state) => state.themeReducer.updatedTheme);

    useEffect(() => {
        // Set initial theme in Redux if not already set
        if (!isDefined(isLight) || !isDefined(updatedTheme)) {
            const isDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
            dispatchThemeSave(dispatch, !isDark, isDark ? "light" : "dark");
        }

        // Update theme when system preference changes
        const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
        const listener = ({ matches: isDark }) => {
            dispatchThemeSave(dispatch, !isDark, isDark ? "light" : "dark");
        };
        mediaQuery.addEventListener("change", listener);

        // Cleanup listener
        return () => {
            mediaQuery.removeEventListener("change", listener);
        };
    }, []);

    // Set isLight based on the checkbox and the default theme values
    function onChange(e) {
        dispatchThemeSave(
            dispatch,
            updatedTheme === "dark" ? !e.target.checked : e.target.checked,
            updatedTheme,
        );
    }

    return (
        <div className="xs:flex mx-4">
            <label className="swap swap-rotate relative px-4 py-2 rounded-lg hover:bg-gradient-to-r hover:from-primary/10 hover:to-primary/5 active:bg-gradient-to-r active:from-primary/15 active:to-primary/8 transition-all duration-300 active:scale-95 cursor-pointer">
                <input
                    type="checkbox"
                    className="theme-controller"
                    value={updatedTheme}
                    checked={updatedTheme === "dark" ? !isLight : isLight}
                    onChange={onChange}
                    id="theme"
                />
                <FontAwesomeIcon
                    icon={updatedTheme === "light" ? faSun : faMoon}
                    className={`swap-on text-xl transition-all duration-300
                        text-base-content/80 hover:text-primary`}
                />
                <FontAwesomeIcon
                    icon={updatedTheme === "light" ? faMoon : faSun}
                    className={`swap-off text-xl transition-all duration-300
                        text-base-content/80 hover:text-primary`}
                />
            </label>
        </div>
    );
};

export default ThemeSelector;
